<template>
    <div class="purchase-insurance-online-service-dialog-container">
        <form class="address_form">
            <v-container>
                <v-dialog
                    v-model="showModal"
                    width="800"
                    content-class="serviceDialog"
                    persistent
                >
                    <v-card>
                        <v-card-title
                            class="headline grey lighten-2"
                            primary-title
                        >
                            Add Service
                        </v-card-title>

                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex md6>
                                        <label for="service_name">Service Name</label>
                                        <v-text-field
                                            label="Service Name"
                                            placeholder=" "
                                            single-line
                                            outline
                                            v-model="service_name"
                                            v-validate="'required|min:2'"
                                            required
                                            :error-messages="errors.collect('service_name')"
                                            data-vv-name="service_name"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex md6>
                                        <label for="company_name">Company Name (optional)</label>
                                        <v-text-field
                                            label="Company Name (optional)"
                                            placeholder=" "
                                            single-line
                                            outline
                                            v-model="company_name"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex md12>
                                        <label for="search_address">Search Address</label>
                                        <v-text-field
                                            label="Search Address"
                                            v-model="search_address"
                                            placeholder=" "
                                            single-line
                                            outline
                                            append-icon="place"
                                            ref="search_address_field"
                                            :autocomplete="'off'"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex md6>
                                        <label for="address_1">Address 1</label>
                                        <v-text-field
                                            label="Address 1"
                                            placeholder=" "
                                            single-line
                                            outline
                                            v-model="address_1"
                                            v-validate="'required|min:2'"
                                            required
                                            :error-messages="errors.collect('address_1')"
                                            data-vv-name="address_1"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex md6>
                                        <label for="address_2">Address 2</label>
                                        <v-text-field
                                            label="Address 2 (optional)"
                                            placeholder=" "
                                            single-line
                                            outline
                                            v-model="address_2"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex md6>
                                        <label for="suburb">Suburb</label>
                                        <v-text-field
                                            label="Suburb"
                                            placeholder=" "
                                            single-line
                                            outline
                                            v-model="suburb"
                                            v-validate="'required|min:2'"
                                            required
                                            :error-messages="errors.collect('suburb')"
                                            data-vv-name="suburb"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex md3>
                                        <label for="postcode">Postcode</label>
                                        <v-text-field
                                            label="Postcode"
                                            placeholder=" "
                                            single-line
                                            outline
                                            v-model="postcode"
                                            v-validate="'required|min:2'"
                                            required
                                            :error-messages="errors.collect('postcode')"
                                            data-vv-name="postcode"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex md3>
                                        <label for="state" class="subheading">State</label>
                                        <v-overflow-btn
                                            v-model="state"
                                            id="state"
                                            :items="au_states"
                                            return-object
                                            editable
                                            flat
                                            outline
                                            required
                                            v-validate="'required'"
                                            :error-messages="errors.collect('state')"
                                            data-vv-name="state"
                                    ></v-overflow-btn>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                round
                                outline 
                                @click="closeModal"
                                large
                                class="cancel-btn"
                            >
                                CANCEL
                            </v-btn>
                            <v-btn
                                round
                                color="primary"
                                flat
                                large
                                @click="saveNewService"
                            >
                                {{ mode }} SERVICE
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-container>
        </form>
    </div>
</template>
<script>
export default {
    $_veeValidate: {
        validator: 'new'
    },
    name: "NewBusinessServiceDialog",
    props: {
        showModal: Boolean,
        mode: {
            type: String,
            default: "ADD"
        }
    },
    data() {
        return {
            search_address_field: undefined,
            search_address: "",
            service_name: !!this.$store.state.sessionDetails.properties.registered_service ? this.$store.state.sessionDetails.properties.registered_service.service_name : "",
            company_name: !!this.$store.state.sessionDetails.properties.registered_service ? this.$store.state.sessionDetails.properties.registered_service.company_name : "",
            address_1: !!this.$store.state.sessionDetails.properties.registered_service ? this.$store.state.sessionDetails.properties.registered_service.address_line_1 : "",
            address_2: !!this.$store.state.sessionDetails.properties.registered_service ? this.$store.state.sessionDetails.properties.registered_service.address_line_2 : "",
            suburb: !!this.$store.state.sessionDetails.properties.registered_service ? this.$store.state.sessionDetails.properties.registered_service.suburb : "",
            postcode: !!this.$store.state.sessionDetails.properties.registered_service ? this.$store.state.sessionDetails.properties.registered_service.postcode : "",
            state: !!this.$store.state.sessionDetails.properties.registered_service ? this.$store.state.sessionDetails.properties.registered_service.state : "",
            country: "Australia",
            au_states: ['NSW','WA','QLD','SA','VIC','TAS','NT','ACT', 'VIC'],
            dictionary: {
                attributes: {
                    service_name: 'Service Name',
                    company_name: 'Company Name',
                    address_1: 'Address 1',
                    address_2: 'Address 2',
                    suburb: 'Suburb',
                    postcode: 'Post Code',
                    state: 'State'
                }
            }
        }
    },
    watch: {},
    methods: {
        async saveNewService() {
            let is_valid = await this.$validator.validateAll();
            if(is_valid) {
                let saveRegisteredServiceDetail = {
                    id: -1,
                    suburb: this.suburb,
                    address_lookup: this.search_address,
                    postcode: this.postcode,
                    service_name: this.service_name,
                    address_line_1: this.address_1,
                    address_line_2: this.address_2,
                    service_approval_number: '',
                    state: this.state,
                    company_name: this.company_name
                }
                this.$store.commit('mutate', {
                    property: "sessionDetails.properties.registered_service",
                    value: saveRegisteredServiceDetail
                });
                this.closeModal();
            }        
        },
        clearFields() {
            this.search_address = "";
            this.index = -1;
            this.id = -1;
            this.service_name = '',
            this.company_name = '',
            this.address_1 = '',
            this.address_2 = '',
            this.suburb = '',
            this.postcode = '',
            this.state = ''
            this.$validator.reset();
        },
        closeModal() {
            this.$store.commit('mutate', {
                property: "NewBusinessServiceDialog",
                value: false
            });
            this.clearFields();
        },
        initGoogleMap() {
            setTimeout(() => {
                if (this.googleMapsApiKey !== '') {
                    this.search_address_field = new google.maps.places.Autocomplete(this.$refs.search_address_field.$el.querySelector('input'));
                    this.search_address_field = new google.maps.places.Autocomplete(this.$refs.search_address_field.$el.querySelector('input'));
                    this.search_address_field.setComponentRestrictions({'country': ['au']});
                    this.search_address_field.addListener('place_changed', this.fillAddress);
                }
            }, 1000);
        },
        fillAddress() {
            let search_address_field = this.search_address_field.getPlace();
            this.search_address = search_address_field.formatted_address;

            this.address_1 = "";
            this.address_2 = "";
            this.suburb = "";
            this.state = "";
            this.postcode = "";

            search_address_field.address_components.forEach(item => {
                let addressType = item.types[0];
                switch (addressType) {
                    case "street_number":
                        this.address_1 = item['short_name'] + " ";
                        break;
                    case "premise":
                        this.address_1 = item['long_name'] + " ";
                        break;
                    case "route":
                        this.address_1 += item['long_name'] + " ";
                        break;
                    case "neighborhood":
                        this.address_1 += item['long_name'] + " ";
                        break;
                    case "locality":
                        if (search_address_field.address_components.length > 7 && search_address_field.address_components.length < 9 && search_address_field.address_components[6].long_name !== "Canada")
                            this.address_1 += item['long_name'] + " ";
                        else
                            this.suburb = item['long_name'] + " ";
                        break;
                    case "postal_town":
                        this.postcode += item['long_name'];
                        break;
                    case "administrative_area_level_1":
                        if (search_address_field.address_components.length < 8)
                            this.state = item['short_name'];
                        break;
                    case "country":
                        this.country = item['long_name'];
                        break;
                    case "postal_code":
                        this.postcode = item['short_name'];
                        break;
                }
            });
        },
        getStreetAddress(_address_component) {
            /* this is just a test function to get the street address alone - only remove if necessary*/
            let _streetaddress = "";
            _address_component.forEach(item => {
                let _address_type = item.types[0];
                switch (_address_type) {
                    case "street_number":
                        _streetaddress += item['long_name'] + " ";
                        break;
                    case "premise":
                        _streetaddress += item['long_name'] + " ";
                        break;
                    case "route":
                        _streetaddress += item['long_name'] + " ";
                        break;
                    case "neighborhood":
                        _streetaddress += item['long_name'] + " ";
                        break;
                }
            });
            return _streetaddress;
        }
    },
    mounted() {
        this.initGoogleMap();
        this.$validator.localize('en', this.dictionary);
    }
}
</script>
<style lang="scss" scoped>
    .app-main-btn {
        font-size: 10px;
        letter-spacing: 2px;
        &.primary {
            background-color: #1CB053 !important;
            color: #fff;
            .btn-icon {
                font-size: 10px;
            }
        }
    }
    .serviceDialog {
        font-family: proxima-soft, sans-serif;
        /deep/ .v-input__append-inner, /deep/ .v-input__append-inner:hover {
            border-left: 0px;
        }
        .v-card__title {
            padding: 15px 25px 0px 25px;
            background-color: #fff !important;
            font-family: proxima-soft, sans-serif !important;
        }
        .v-card__text {
            padding: 15px;
            background-color: #fff !important;
            font-family: proxima-soft, sans-serif !important;
            .container {
                padding: 10px;
            }
            /deep/ .v-input__slot {
                border-color: #F0F1F3 !important;
            }
        }
        .v-card__actions {
            .v-btn {
                background-color: #1CB053 !important;
                color: #fff !important;
                letter-spacing: 2px;
                font-family: proxima-soft, sans-serif;
                font-size: 0.8rem;
                letter-spacing: 2px;
                font-family: proxima-soft, sans-serif;
                height: 40px;
                &.cancel-btn {
                    font-family: proxima-soft, sans-serif !important;
                    background: #fff !important;
                    color: #1CB053 !important;
                    border: 1px solid #1CB053;
                }
            }
        }
    }
</style>